import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function CeilingPlanesContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="ceilingPlane" />
    </SceneMenuContent>
  );
}
